export const SUPERADMIN = 'SUPER_ADMIN';

export const permittedRoles = [
  SUPERADMIN,
  'BUSINESS_ACCOUNT'
];
